export const EXPECTED_FIELDS = [
  "Primary Campaign Source",
  "Marketing Influenced",
  "Submission Date",
  "Sales Executive",
  "First Name",
  "Last Name",
  "Email",
  "Phone",
  "Company",
  "Job Title",
  "Address",
  "Classification",
  "Application in Use",
  "Received Demo",
  "Ranking",
];

export const FIELD_TO_COL = {
  "Primary Campaign Source": "primary_campaign_source",
  "Marketing Influenced": "marketing_influenced",
  "Submission Date": "submission_date",
  "Sales Executive": "sales_executive",
  "First Name": "first_name",
  "Last Name": "last_name",
  "Email": "email",
  "Phone": "phone",
  "Company": "company",
  "Job Title": "job_title",
  "Address": "address",
  "Classification": "classification",
  "Application in Use": "application_in_use",
  "Received Demo": "received_demo",
  "Ranking": "ranking",
  "Total Influenced Pipeline": "total_influenced_pipeline",
};

export const PIE_COLORS = [
  "#22D3EE",
  "#38BDF8",
  "#2DD4BF",
  "#60A5FA",
  "#818CF8",
  "#67E8F9",
  "#A78BFA",
  "#34D399",
  "#22D3EEaa",
  "#38BDF8aa",
];

export const ROLES = { ADMIN: "admin", MANAGER: "manager", VIEWER: "viewer" };
